import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiHeart, FiStar } = FiIcons;

const MotivationalQuotes = () => {
  const [currentQuote, setCurrentQuote] = useState(0);

  const quotes = [
    {
      text: "Before I formed you in the womb I knew you, before you were born I set you apart.",
      source: "Jeremiah 1:5",
      type: "verse"
    },
    {
      text: "For I know the plans I have for you, plans to prosper you and not to harm you, to give you hope and a future.",
      source: "Jeremiah 29:11",
      type: "verse"
    },
    {
      text: "Commit to the Lord whatever you do, and he will establish your plans.",
      source: "Proverbs 16:3",
      type: "verse"
    },
    {
      text: "The first draft of anything is just to tell yourself the story.",
      source: "Anne Lamott",
      type: "author"
    },
    {
      text: "Write hard and clear about what hurts. Don't be ashamed of your story.",
      source: "Anne Lamott",
      type: "author"
    },
    {
      text: "God has given you a story to tell. Don't let fear keep you from sharing it.",
      source: "Lysa TerKeurst",
      type: "author"
    },
    {
      text: "Your words have the power to change someone's day, someone's perspective, someone's entire life.",
      source: "Rachel Hollis",
      type: "author"
    },
    {
      text: "Write what should not be forgotten.",
      source: "Isabel Allende",
      type: "author"
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentQuote((prev) => (prev + 1) % quotes.length);
    }, 8000); // Change every 8 seconds

    return () => clearInterval(interval);
  }, []);

  const quote = quotes[currentQuote];

  return (
    <motion.div
      key={currentQuote}
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10 }}
      transition={{ duration: 0.5 }}
      className="bg-gradient-to-r from-sage-green/10 to-soft-blue/10 rounded-lg p-4 mb-6 border border-sage-green/20"
    >
      <div className="flex items-start space-x-3">
        <SafeIcon 
          icon={quote.type === 'verse' ? FiHeart : FiStar} 
          className={`mt-1 ${quote.type === 'verse' ? 'text-sage-green' : 'text-soft-blue'}`} 
        />
        <div className="flex-1">
          <p className="text-warm-brown/80 italic text-sm leading-relaxed">
            "{quote.text}"
          </p>
          <p className="text-warm-brown/60 text-xs mt-2">
            - {quote.source}
          </p>
        </div>
      </div>
    </motion.div>
  );
};

export default MotivationalQuotes;